enum ChatContextInteractionSource {
    ChatContextMenu = 1,
    NavidationBar = 2,
    SearchResultItem = 3
}

export { ChatContextInteractionSource };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/chat-context-menu/chat-context-interaction-source.ts